<template>
  <div>
    <ul v-if="asList" class="m-0 pl-3">
      <li v-for="(value, name) in data" :key="name" class="p-0">{{ name }}: {{ value }}</li>
    </ul>
    <table v-else class="table-sm m-0">
      <tr v-for="(value, name) in data" :key="name" class="p-0 m-0">
        <td class="p-0 pr-1 m-0 font-weight-light border-right">{{ name }}</td>
        <td class="pl-1 m-0">{{ value }}</td>
      </tr>
    </table>
  </div>

</template>

<script>

export default {

  name: "MetaDataDetails",
  components: {},
  props: {
    asList: {
      type: Boolean,
      description: "If `true` - will be list, otherwise will be table."
    },
    data: {
      type: Object,
      required: false,
      description: 'Metadata info.'
    },
  },
}
</script>

<style scoped>
.table tr:first-child td {
  border: none;
}
</style>
